<template>
  <h4>Arming Roster Report</h4>
  <div class="legend">
    <div class="redDate legendItem">
      Expired
    </div>
    <div class="orangeDate legendItem">
      Expires within 30 Days
    </div>
    <div class="yellowDate legendItem">
      Expires within 60 Days
    </div>
    <div class="purpleDate legendItem">
      Expires within 90 Days
    </div>
  </div>
  <DataTableComponent 
  v-if="this.getAllUrl" 
  :data-url="this.getAllUrl" 
  :column-list-d-b="this.personDataColumnNames"
  :column-list-pretty="this.personDataColumnNamesPretty" 
  :date-column-indexes="[5,6,7]" 
  :order-column-index="0" 
  :rows-per-page="-1" 
  :show-search="true" 
  plural-data-name="people"
  order-direction="asc" 
  ref="personsDatatable"
  :show-action-column="false"
  :show-paging="false"
  >

    <template v-slot:extraColumnHeaders>

      <th>Deploy End Date</th>

      <th>Contract End Date</th>

      <th>Weapon Qual Expiration Date</th>

    </template>


    <template #extraColumns="extraColumnRowData">

      <td :data-sort="extraColumnRowData.deployEndDate" :class="getColorFromDate(extraColumnRowData.deployEndDate)">
        {{ extraColumnRowData.deployEndDatePretty }}
      </td>

      <td :data-sort="extraColumnRowData.contractEndDate" :class="getColorFromDate(extraColumnRowData.contractEndDate)">
        {{ extraColumnRowData.contractEndDatePretty }}
      </td>

      <td :data-sort="extraColumnRowData.weaponsQualExpireDate" :class="getColorFromDate(extraColumnRowData.weaponsQualExpireDate)">
        {{ extraColumnRowData.weaponsQualExpireDatePretty }}
      </td>

    </template>

  </DataTableComponent>
</template>

<script>

import DataTableComponent from "@/components/dataSupport/DataTable.vue";
import { store } from "@/store/store.js";

export default {
  components: {
    DataTableComponent,

  },
  data() {
    return{
      getAllUrl:null,
    store,
    personDataColumnNames: ['lastName', 'firstName', 'contractNumber', 'passportNumber', 'armedYN',],
    personDataColumnNamesPretty: ['Last Name', 'First Name', 'Contract Number', 'Passport Number', 'Armed?'],
    }
   
  },
  created() {
    //console.log(store.authenticatedUser);
    this.getAllUrl = store.webAPIUrl + "people/GetArmingRoster/" + store.authenticatedUser.userGUID;
  },
  computed: {},
  methods: {
    getColorFromDate(date){
      date;
      var numDaysBetween = function(d1, d2) {
        var diff = Math.abs(d1.getTime() - d2.getTime());
        return diff / (1000 * 60 * 60 * 24);
      };

      var numDaysFromNow = numDaysBetween(new Date(date), new Date()); 

      if(new Date(date) <= new Date()){
        return "redDate";
      }
      if(numDaysFromNow > 0 && numDaysFromNow <= 30){
        return "orangeDate";
      }
      if(numDaysFromNow > 0 && numDaysFromNow <= 60){
        return "yellowDate";
      }
      if(numDaysFromNow > 0 && numDaysFromNow <= 90){
        console.log(numDaysFromNow);
        return "purpleDate";
      }
    }
  },
};
</script>

<style scoped>
.purpleDate{
  background-color:rgb(249, 137, 249);
}
.yellowDate{
  background-color:yellow;
}
.orangeDate{
  background-color:orange
}
.redDate {
  background-color: rgb(253, 179, 179);
  text-transform: capitalize;
  text-transform: capitalize;
    }
.legend{
  display: flex;
  justify-content: space-around;
  width:665px;
}
.legendItem{
  border-radius: 8px;
  padding:5px;
}
</style>
